import { render, staticRenderFns } from "./type80.vue?vue&type=template&id=1cc1432e&scoped=true"
import script from "./type80.vue?vue&type=script&lang=js"
export * from "./type80.vue?vue&type=script&lang=js"
import style0 from "./type80.vue?vue&type=style&index=0&id=1cc1432e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!D:\\work\\dys\\duyisheng-admin-ui\\node_modules\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cc1432e",
  null
  
)

export default component.exports